module.exports = __webpack_public_path__ + "static/img/money-important@2x.f940803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/money-important@2x.png
// module id = Axr/
// module chunks = 1